<template>
  <!-- 確認メール送信画面 -->
  <CContainer class="d-flex flex-column justify-content-center min-vh-100" style="width:480px">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <CForm>
                <h1>確認メール送信</h1>
                <p class="text-muted">
                  下記、メールアドレス宛に、パスワード再設定ページへのURLを送信いたしました。
                  <br />メールが届いていない場合、メールアドレスの入力誤りや未登録などが考えられます。
                </p>
                <div>
                  <p>{{ email }}</p>
                </div>
              </CForm>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  props: ['email'],
  data() {
    return {
      mailaddress: ""
    };
  }
};
</script>